export enum  ContractType{

    EVENTUAL = 'EVENTUAL' ,

    FIXED = 'FIXED' ,

    END_OF_WORK = 'END_OF_WORK',

    ERTE = 'ERTE'
}